import React, { useState, useRef, useEffect } from 'react';
import t from 'prop-types'; // import { DraggableCore } from 'react-draggable'

import { is_touch_device } from '../../util';
import useStatePosicionEnRango from '../../util/use-state-posicion-en-rango';
import useArrastrable from '../../util/use-arrastrable';
var NOMBRE_EVENTO_ACTIVAR_EDITOR = is_touch_device() ? 'touchend' : 'mouseup';

function VinculoFlotante(_ref) {
  var x = _ref.x,
      y = _ref.y,
      offset = _ref.offset,
      minX = _ref.minX,
      maxX = _ref.maxX,
      onMover = _ref.onMover,
      onActivarEdicion = _ref.onActivarEdicion;

  var _useStatePosicionEnRa = useStatePosicionEnRango(x, y, minX, maxX, 0, 99),
      pos = _useStatePosicionEnRa[0],
      setPos = _useStatePosicionEnRa[1];

  var _useState = useState(false),
      recienArrastrado = _useState[0],
      setRecienArrastrado = _useState[1];

  var rootRef = useRef(null);

  var _useArrastrable = useArrastrable({
    elementRef: rootRef,
    onArrastrando: function onArrastrando(posicion) {
      return setPos(posicion);
    },
    onStop: function onStop(_ref2) {
      var x = _ref2.x,
          y = _ref2.y;
      onMover && onMover(x, y);
      setRecienArrastrado(true);
    }
  }),
      arrastrando = _useArrastrable.arrastrando;

  useEffect(function () {
    function handleActivarEditor(e) {
      if (arrastrando || recienArrastrado) {
        setRecienArrastrado(false);
        return;
      }

      onActivarEdicion && onActivarEdicion();
    }

    var elemento = rootRef.current;
    elemento.addEventListener(NOMBRE_EVENTO_ACTIVAR_EDITOR, handleActivarEditor);
    return function () {
      return elemento.removeEventListener(NOMBRE_EVENTO_ACTIVAR_EDITOR, handleActivarEditor);
    };
  }, [arrastrando, recienArrastrado, rootRef, onActivarEdicion]);
  var style = {
    left: pos.x + offset.x + '%',
    top: pos.y + offset.y + '%',
    // whiteSpace: 'normal',
    // zIndex: 10, 
    pointerEvents: "auto",
    cursor: arrastrando ? 'move' : 'pointer' // width: '10%',
    // height: '6%',
    // backgroundImage: 'url(css/imagenes/barra-herramientas/herramientaVinculo.png)',
    // backgroundSize: 'cover'

  };
  return React.createElement('div', {
    className: 'botonVinculoEnPagina',
    style: style,
    ref: rootRef
  });
}

VinculoFlotante.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.string.isRequired,

  /** posicion horizontal del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  x: t.number.isRequired,

  /** posicion vertical del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  y: t.number.isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),

  /** minimo valor de x */
  minX: t.number,

  /** maximo valor de x */
  maxX: t.number,

  /** 
   * Evento que lanza el componente para informar de la nueva posición del texto. 
   * Se llamará con los parametros: (x, y) => {...} 
   * 
   * */
  onMover: t.func.isRequired,

  /**
   * Evento que lanza el componente para informar de que el usuario quiere editar el texto.
   */
  onActivarEdicion: t.func.isRequired
} : {};
VinculoFlotante.defaultProps = {
  activo: true,
  x: 0,
  y: 0,
  offset: {
    x: 0,
    y: 0
  },
  minX: 0,
  maxX: 95
};
export default VinculoFlotante;